<script>
import { mapActions } from 'vuex';
import i18n from "@/plugins/i18n";

export default {
    data() {
        return {
            loading: true,
            isResolved: false,
            isError: false
        }
    },

    mounted() {
        this.performRequest();
    },

    methods: {
        ...mapActions("company", [
            "getSustainfinityLinkById",
            "acceptSustainfinityLink",
            "declineSustainfinityLink",
            "blockCompany"
        ]),

        async performRequest() {
            try {
                await this.setLoading(true);
                const action = this.$route.query.action;
                
                if (!action) {
                    throw new Error("No action found!");
                }

                const [type, sust_link_id, sender_company_id, receiver_company_id, receiver_user_id] = action.split("_");

                await this._getSustainfinityLinkById(sust_link_id);

                if (this.isResolved) {
                    return;
                } else if (type === "accept") {
                    await this._acceptSustainfinityLink(Number(sust_link_id), Number(receiver_user_id));
                } else if (type === "reject") {
                    await this._declineSustainfinityLink(Number(sust_link_id), Number(receiver_user_id));
                } else if (type === "block") {
                    await this._blockCompany(Number(sender_company_id), Number(receiver_company_id), Number(sust_link_id), Number(receiver_user_id));
                }
            } catch (error) {
                console.error(error.message);
                await this.setIsError(true);
            } finally {
                await this.setLoading(false);
            }
        },

        async _getSustainfinityLinkById(id) {
            const params = {
                sustainfinity_link_id: id,
            }

            await this.getSustainfinityLinkById(params)
                .then( async (res) => {
                    await this.setIsResolved(res.data.sustainfinity_link.is_accepted == true || res.data.sustainfinity_link.is_deleted == true);
                })
        },

        async _acceptSustainfinityLink(sust_id, user_id) {
            const params = {
                sustainfinity_link_id: sust_id,
                created_by: user_id
            }

            await this.acceptSustainfinityLink(params)
        },

        async _declineSustainfinityLink(sust_id, user_id) {
            const params = {
                sustainfinity_link_id: sust_id,
                deleted_by: user_id
            }

            await this.declineSustainfinityLink(params)
        },

        async _blockCompany(sender_company_id, receiver_company_id, sustainfinity_link_id, user_id) {
            const params = {
                blocked_company_id: sender_company_id,
                company_id: receiver_company_id,
                sustainfinity_link_id: sustainfinity_link_id,
                deleted_by: user_id
            }

            await this.blockCompany(params)
        },

        async setLoading(bool) {
            this.loading = bool;
        },

        async setIsResolved(bool) {
            this.isResolved = bool;
        },

        async setIsError(bool) {
            this.isError = bool;
        }
    }
}
</script>

<template>
    <div class="link-company-page flex-all-centered-row">
        <div class="flex-all-centered-row" v-if="loading">
            <b-spinner variant="success"></b-spinner>
        </div>
        <div class="flex-all-centered-row" v-if="isResolved">
            {{ $t('notifications.is_resolved') }}
        </div>
        <div class="flex-all-centered-row" v-if="isError">
            {{ $t('notifications.is_error') }}
        </div>
        <div class="flex-all-centered-row" v-if="!loading && !isResolved && !isError">
            {{ $t('notifications.is_fulfilled') }}
        </div>
    </div>
</template>

<style lang='scss' scoped>
    .link-company-page {
        height: 100vh;
        background-color: rgba(112, 128, 144, 0.5);
        color: var(--sustainfinity-navy);
        font-size: 2.5em;

        > div {
            width: 100%;
            height: 100%;
            text-align: center;
        }
    }
</style>